import * as React from 'react';
import * as _ from 'lodash';
import { Link } from 'react-router';
import Helmet from 'react-helmet';
import Lightbox from 'react-images';
import EXTERNAL_MERCH_LIST from './externalMerchList';
import ExternalMerch from './ExternalMerch';
import Merch from './Merch';
import SubscribeDialogCTA from '../../App/SubscribeDialogCTA';
export default function () {
    function repeatMerch1(merch, merchIndex) {
        return React.createElement(Merch, _.assign({}, {
            'key': merch.id,
            'onSelectVariant': this.props.onSelectVariant,
            'openImagesModal': this.props.openImagesModal
        }, merch));
    }
    function repeatMerch2(merch, merchIndex) {
        return React.createElement(ExternalMerch, _.assign({}, {
            'key': 'external-' + merch.id,
            'openImagesModal': this.props.openImagesModal
        }, merch));
    }
    return React.createElement('div', { 'id': 'MerchList' }, React.createElement(Helmet, {}, React.createElement('title', {}, 'Merch | Stan Winston School of Character Arts'), React.createElement('meta', {
        'name': 'description',
        'content': 'Find the best products in the field of Special Effects Character Creation, Character Design & Makeup FX'
    }), React.createElement('meta', {
        'property': 'og:title',
        'content': 'Merch | Stan Winston School of Character Arts'
    }), React.createElement('meta', {
        'property': 'og:description',
        'content': 'Find the best products in the field of Special Effects Character Creation, Character Design & Makeup FX'
    }), React.createElement('meta', {
        'property': 'og:type',
        'content': 'product'
    })), React.createElement('div', { 'className': 'wrapper' }, React.createElement('section', { 'className': 'heading' }, React.createElement('h1', {}, 'Store'))), !this.props.isSubscribed ? React.createElement('div', {
        'className': 'wrapper-1080 subscribe',
        'key': '1121'
    }, React.createElement('div', { 'className': 'subscription-holder' }, React.createElement('p', {}, '\n        SUBSCRIPTION PLANS -\n        Unlimited On-Demand\n        Course Access & Special Discounts\n      '), React.createElement(SubscribeDialogCTA, {}, React.createElement('div', { 'className': 'subscribe-btn btn -thin -orange' }, React.createElement('span', {}, 'Subscribe'))))) : null, React.createElement.apply(this, [
        'div',
        { 'className': 'merch-list-content wrapper-1080' },
        _.map(this.props.merchs, repeatMerch1.bind(this)),
        _.map(EXTERNAL_MERCH_LIST, repeatMerch2.bind(this))
    ]), React.createElement('div', { 'className': 'wrapper-1080' }, React.createElement('div', { 'className': 'group-subs-holder' }, React.createElement('p', {}, '\n        Group Learning Plans - Discounted Course Access for Multiple Users\n      '), React.createElement('a', {
        'className': 'courses-btn btn -thin -orange',
        'href': 'https://pages.stanwinstonschool.com/group-subscription-info/'
    }, '\n        See more\n      '))), React.createElement('div', { 'className': 'wrapper-1080' }, React.createElement('div', { 'className': 'explore-courses-holder' }, React.createElement('p', {}, '\n        Video Courses by the Masters of Character Creation\n      '), React.createElement(Link, {
        'to': '/tutorials',
        'className': 'courses-btn btn -thin -orange'
    }, 'Explore Courses'))), React.createElement(Lightbox, {
        'images': this.props.imagesModal,
        'isOpen': this.props.modalIsOpen,
        'onClose': this.props.closeModal,
        'theme': this.constructor.getLightBoxTheme(),
        'showCloseButton': true
    }));
}